export enum AppModuleRoutes {
    AUTH = 'auth',
    DASHBOARD = 'dashboard'
}
